import { FieldRepository } from '@aipb/gulliver/castor/data-access';
import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import * as newLuceneParser from 'lucene';

const LEFT_BRACKET = '(',
  RIGHT_BRACKET = ')',
  STAR = '*',
  IMPLICIT = '<implicit>';

@Injectable({
  providedIn: 'root'
})
export class QueryService {
  constructor(private fieldRepository: FieldRepository) {}

  public parseQuery(coreId: string, query: string): string[] {
    let q = [];

    try {
      const parsedSolrQuery = newLuceneParser.parse(query);
      q = this.parse(coreId, [], parsedSolrQuery);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return q.map((s) => s.replace(/\\/g, ''));
  }

  public getPrettyQuery(coreId: string, query: string): string {
    let q = '';

    try {
      const parsedSolrQuery = newLuceneParser.parse(query);

      q = this.parsePrettyQuery(coreId, '', parsedSolrQuery);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return q.substring(0, q.length - 3).replace(/\\/g, '');
  }

  private parsePrettyQuery(coreId: string, query: string, parsedSolrQuery): string {
    if (parsedSolrQuery['term']) {
      query += parsedSolrQuery['term'];
      query += ' | ';
    }

    if (parsedSolrQuery['term_min'] && parsedSolrQuery['term_max']) {
      if (parsedSolrQuery['term_min'] === '*') {
        query += '* ';
      } else {
        query += `${format(new Date(parsedSolrQuery['term_min']), 'dd.MM.yyyy')} `;
      }

      query += '- ';

      if (parsedSolrQuery['term_max'] === '*') {
        query += '*';
      } else {
        query += `${format(new Date(parsedSolrQuery['term_max']), 'dd.MM.yyyy')}`;
      }

      query += ' | ';
    }

    if (parsedSolrQuery['left']) {
      query = this.parsePrettyQuery(coreId, query, parsedSolrQuery['left']);
    }

    if (parsedSolrQuery['right']) {
      query = this.parsePrettyQuery(coreId, query, parsedSolrQuery['right']);
    }

    return query;
  }

  private parse(coreId, query = [], parsedSolrQuery) {
    if (!parsedSolrQuery['term'] && parsedSolrQuery['field']) {
      const searchField = this.fieldRepository.getSearchField(coreId, this.getFieldId(parsedSolrQuery['field']));
      const registerField = this.fieldRepository.getRegisterField(coreId, this.getFieldId(parsedSolrQuery['field']));

      const field = searchField || registerField;
      query.push(`${field ? field.fieldName : parsedSolrQuery['field']}: `);
    }

    if (parsedSolrQuery['term']) {
      const searchField = this.fieldRepository.getSearchField(coreId, this.getFieldId(parsedSolrQuery['field']));
      const registerField = this.fieldRepository.getRegisterField(coreId, this.getFieldId(parsedSolrQuery['field']));
      const field = searchField || registerField;
      const fieldName = parsedSolrQuery['field'] === STAR ? STAR : field ? field.fieldName : parsedSolrQuery['field'];

      query.push(`${fieldName && fieldName !== '<implicit>' ? fieldName + ': ' : ''}<b>${parsedSolrQuery['term']}</b>`);
    }

    if (parsedSolrQuery['term_min'] && parsedSolrQuery['term_max']) {
      const searchField = this.fieldRepository.getSearchField(coreId, this.getFieldId(parsedSolrQuery['field']));
      const registerField = this.fieldRepository.getRegisterField(coreId, this.getFieldId(parsedSolrQuery['field']));

      const field = searchField || registerField;
      let start = '*';
      if (parsedSolrQuery['term_min'] !== '*') {
        start = format(new Date(parsedSolrQuery['term_min']), 'dd.MM.yyyy');
      }

      let end = '*';
      if (parsedSolrQuery['term_max'] !== '*') {
        end = format(new Date(parsedSolrQuery['term_max']), 'dd.MM.yyyy');
      }

      query.push(
        `${
          parsedSolrQuery['field'] === STAR ? STAR : field ? field.fieldName : parsedSolrQuery['field']
        } = ${start} - ${end}`
      );
    }

    /*if (parsedSolrQuery['parenthesized']) {
      query.push(LEFT_BRACKET);
    }*/

    if (parsedSolrQuery['left']) {
      query = this.parse(coreId, query, parsedSolrQuery['left']);
    }

    if (parsedSolrQuery['operator'] && parsedSolrQuery['operator'] !== IMPLICIT) {
      //query.push(parsedSolrQuery['operator']);
    }

    if (parsedSolrQuery['operator'] && parsedSolrQuery['operator'] === 'NOT') {
      query.push(parsedSolrQuery['operator']);
    }

    if (parsedSolrQuery['right']) {
      query = this.parse(coreId, query, parsedSolrQuery['right']);
    }

    /*if (parsedSolrQuery['parenthesized']) {
      query.push(RIGHT_BRACKET);
    }*/

    return query;
  }

  private getFieldId(field: string): string {
    return field.split('_')[0];
  }
}
